const NODE_ENV = process.env.REACT_APP_NODE_ENV;

const getUserKey = () => {
  const isDevelopment = NODE_ENV === 'development';
  if (isDevelopment) {
    return "gleamdesk-dev"
  }

  return "gleamdesk-user";
}

export default getUserKey;